"use client"

import { useState, useRef, useEffect } from "react"
import { FaRobot } from "react-icons/fa"
import axios from "axios"

// ✅ Chatbot Component
const ChatbotPopup = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [messages, setMessages] = useState([
    {
      sender: "bot",
      text: "HI! I am Genie  your elevator specialist! How can I help you today?",
    },
  ])
  const [stage, setStage] = useState("initial")
  const [loading, setLoading] = useState(false)
  const [modifyStepIndex, setModifyStepIndex] = useState(0)
  const [modifyAnswers, setModifyAnswers] = useState([])
  const [userDetails, setUserDetails] = useState({ name: "", address: "", phone: "" })
  const [showPopup, setShowPopup] = useState(false) // For brochure popup
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
  })
  const [formErrors, setFormErrors] = useState({})
  const [submitStatus, setSubmitStatus] = useState(null)
  const [isSubmitted, setIsSubmitted] = useState(false)
  const handleSubmit = (event) => {
    event.preventDefault()
    // Simulate form submission, e.g., make an API call or submit to PHP
    setIsSubmitted(true)

    // Optionally, you can reset the form or wait before actually submitting
    setTimeout(() => {
      // Reset form (if needed)
      // document.getElementById("contactForm").reset();
      // Optionally, you can submit the form or handle the action here.
    }, 2000) // 2-second delay before submitting or doing another action
  }

  const chatbotRef = useRef(null)

  const validateForm = () => {
    const errors = {}
    let isValid = true

    if (!formData.name) {
      errors.name = "Name is required."
      isValid = false
    }
    if (!formData.mobile || !/^\d{10}$/.test(formData.mobile)) {
      errors.mobile = "Enter a valid 10-digit mobile number."
      isValid = false
    }
    if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      errors.email = "Enter a valid email address."
      isValid = false
    }

    setFormErrors(errors)
    return isValid
  }
  const handleDownloadBrochure = async (e) => {
    e.preventDefault()
    if (validateForm()) {
      setLoading(true)
      setSubmitStatus(null)

      try {
        // Create form data
        const formDataToSend = new FormData()
        formDataToSend.append("name", formData.name)
        formDataToSend.append("mobile", formData.mobile)
        formDataToSend.append("email", formData.email)

        // Use the correct path to the PHP file in the assets folder
        const phpEndpoint = "https://admin.lumetiq.in/sendEmail.php"
        // Alternative: use the full URL if needed
        // const phpEndpoint = 'https://palegoldenrod-panther-953114.hostingersite.com/assets/sendEmail.php';

        console.log("Sending request to:", phpEndpoint)

        const response = await axios.post(phpEndpoint, formDataToSend, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })

        console.log("Response:", response)

        if (response.status === 200) {
          setSubmitStatus({ type: "success", message: "Email sent successfully!" })

          // Download the brochure
          const brochureUrl = "assets/LUMETIQ CATALOG-2020.pdf"
          const link = document.createElement("a")
          link.href = brochureUrl
          link.download = "Brochure.pdf"
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)

          // Reset form
          setShowPopup(false)
          setFormData({ name: "", mobile: "", email: "" })
        } else {
          setSubmitStatus({ type: "error", message: "Failed to send email. Please try again." })
        }
      } catch (error) {
        console.error("Error details:", error)

        let errorMessage = "Network error occurred. Please check your connection and try again."

        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.error("Error response data:", error.response.data)
          console.error("Error response status:", error.response.status)

          if (error.response.status === 404) {
            errorMessage = "Email service not found. Please check the path to your PHP file."
          } else if (error.response.status === 403) {
            errorMessage = "Access to email service is forbidden. Please check server permissions."
          }
        } else if (error.request) {
          // The request was made but no response was received
          console.error("Error request:", error.request)
          errorMessage = "No response from server. Please try again later."
        }

        setSubmitStatus({ type: "error", message: errorMessage })
      } finally {
        setLoading(false)
      }
    }
  }
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({ ...prevData, [name]: value }))
    // Clear error for this field when user starts typing
    if (formErrors[name]) {
      setFormErrors((prev) => ({ ...prev, [name]: null }))
    }
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (chatbotRef.current && !chatbotRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside)
    } else {
      document.removeEventListener("mousedown", handleClickOutside)
    }

    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [isOpen])

  const modifyQuestions = [
    "Type of existing lift: Geared or Gearless?",
    "Type of existing cabin: MS or SS?",
    "Type of existing doors: MS Auto / SS Auto door?",
    "Desired modifications?",
    "Application: Bungalow, high rise building, hospital, or goods lift?",
  ]

  const modifyOptions = [
    ["Geared", "Gearless"],
    ["MS", "SS"],
    ["MS Auto Door", "SS Auto Door"],
    ["Change entire lift", "Change cabin only", "Change doors only"],
    ["Bungalow", "High-rise building", "Hospital", "Goods lift"],
  ]

  const handleOptionClick = (option) => {
    const newMessages = [...messages, { sender: "user", text: option }]
    setLoading(true)
    setMessages([...newMessages, { sender: "bot", text: "loading ..." }])

    setTimeout(() => {
      let botMsg = ""
      let nextStage = stage

      if (stage === "initial") {
        if (option.startsWith("1")) {
          botMsg =
            "That's great! In today's fast world, lifts are utmost necessary. Let me have a few more details please:"
          nextStage = "installOptions"
        } else if (option.startsWith("2")) {
          botMsg =
            "That's a great idea! Let us help you in converting your existing lift into a high-end elevator. Kindly answer a few quick questions."
          nextStage = "modifyDetails"
          setModifyStepIndex(0)
          setModifyAnswers([])
        } else if (option.startsWith("3")) {
          botMsg =
            "Sure! I would be happy to connect you with the concerned team!\nYou can reach them on: +91 95741 00028"
          nextStage = "final"
        } else if (option.startsWith("4")) {
          setShowPopup(true) // ✅ Show brochure popup
          botMsg = "✅ Thank you! Please fill the form to download your company catalogue."
          nextStage = "final"
        }
      } else if (stage === "installOptions") {
        botMsg = "Thanks! Kindly share your contact details so we can proceed."
        nextStage = "collectUserDetails"
        // setShowContactForm(true); // ✅ This shows the form
      } else if (stage === "modifyDetails") {
        const newAnswers = [...modifyAnswers, option]
        setModifyAnswers(newAnswers)

        if (modifyStepIndex < modifyQuestions.length - 1) {
          botMsg = modifyQuestions[modifyStepIndex + 1]
          setModifyStepIndex(modifyStepIndex + 1)
        } else {
          botMsg = "Thanks for the information! Kindly share your name, address, and telephone number."
          nextStage = "collectUserDetails"
        }
      }

      newMessages.push({ sender: "bot", text: botMsg })
      setMessages(newMessages)
      setStage(nextStage)
      setLoading(false)
    }, 1000)
  }

  const handleBack = () => {
    setMessages([
      ...messages,
      { sender: "user", text: "Back to options" },
      { sender: "bot", text: "Welcome back! How can I assist you?" },
    ])
    setStage("initial")
  }

  const getOptions = () => {
    if (stage === "modifyDetails") {
      return [...modifyOptions[modifyStepIndex], "Back to main options"]
    }

    const options = []
    if (stage === "initial") {
      options.push(
        "1. I want to install a new lift",
        "2. Modify / Renovate existing lift",
        "3. Talk to sales or support team",
        "4. Know about your company",
      )
    } else if (stage === "installOptions") {
      options.push(
        "1. Lift for private bungalow",
        "2. Commercial / high rise residential building lift",
        "3. Goods lift",
        "4. Hospital lift",
      )
    }

    // Always add "Back to main options"
    options.push("Back to main options")

    return options
  }

  return (
    <>
      <div style={{ position: "fixed", bottom: "20px", right: "20px", zIndex: 999999 }}>
        {isOpen && (
          <div
            ref={chatbotRef}
            style={{
              backgroundColor: "#fff",
              width: "350px",
              height: "500px",
              border: "2px solid #029FE3",
              borderRadius: "15px",
              boxShadow: "0 4px 15px rgba(0, 0, 0, 0.15)",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                backgroundColor: "#029FE3",
                color: "#fff",
                padding: "15px",
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "600",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
              }}
            >
              <FaRobot /> Lumetiq
            </div>

            <div
              style={{
                flex: 1,
                padding: "15px",
                overflowY: "auto",
                backgroundColor: "#f8f9fa",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                {messages.map((msg, index) => {
                  const isBot = msg.sender === "bot"
                  return (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: isBot ? "flex-start" : "flex-end",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: isBot ? "#e3f2fd" : "#029FE3",
                          color: isBot ? "#2c3e50" : "white",
                          padding: "12px 18px",
                          borderRadius: "20px",
                          maxWidth: "75%",
                          whiteSpace: "pre-wrap",
                        }}
                      >
                        <div>{msg.text}</div>

                        {isBot && index === messages.length - 1 && !loading && stage !== "collectUserDetails" && (
                          <div style={{ marginTop: "10px", display: "flex", flexWrap: "wrap", gap: "10px" }}>
                            {getOptions().map((option, i) => (
                              <button
                                key={i}
                                onClick={() =>
                                  option === "Back to main options" ? handleBack() : handleOptionClick(option)
                                }
                                style={buttonStyle}
                              >
                                {option}
                              </button>
                            ))}
                          </div>
                        )}

                        {loading && <div style={{ fontSize: "18px", color: "#029FE3" }}>...</div>}

                        {stage === "collectUserDetails" && index === messages.length - 1 && (
                          <div>
                            {!isSubmitted ? (
                              <form
                                id="contactForm"
                                action="assets/chatbox.php"
                                method="POST"
                                enctype="application/x-www-form-urlencoded"
                              >
                                <input
                                  type="text"
                                  name="name"
                                  placeholder="Enter your name"
                                  required
                                  style={inputStyle}
                                />
                                <input
                                  type="phone"
                                  name="phone"
                                  placeholder="Enter your phone"
                                  required
                                  style={inputStyle}
                                />
                                <input name="address" placeholder="Enter your address" required style={inputStyle} />
                                {/* Add hidden inputs for modifyAnswers if they exist */}
                                {stage === "collectUserDetails" &&
                                  modifyAnswers.length > 0 &&
                                  modifyAnswers.map((answer, index) => (
                                    <input
                                      key={index}
                                      type="hidden"
                                      name={`modifySelections[${index}]`}
                                      value={answer}
                                    />
                                  ))}
                                <button type="submit" style={inputStyle}>
                                  Send
                                </button>
                              </form>
                            ) : (
                              <div style={{ marginTop: "20px", fontSize: "16px", color: "green" }}>
                                Thanking you for visiting LUMETIQ group of companies! Have a great time ahead!
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        )}

        <button
          onClick={() => setIsOpen(!isOpen)}
          style={{
            backgroundColor: "#029FE3",
            color: "#fff",
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            position: "fixed",
            bottom: isOpen ? "540px" : "1px",
            right: "20px",
            border: "none",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "bottom 0.3s ease-in-out",
            boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.2)",
          }}
        >
          <FaRobot size={28} />
        </button>
      </div>

      {showPopup && <BrochurePopup onClose={() => setShowPopup(false)} />}
    </>
  )
}

// ✅ Brochure Popup Component
const BrochurePopup = ({ onClose }) => {
  const [formData, setFormData] = useState({ name: "", mobile: "", email: "" })
  const [formErrors, setFormErrors] = useState({})
  const [loading, setLoading] = useState(false)
  const [submitStatus, setSubmitStatus] = useState(null)
  const [showPopup, setShowPopup] = useState(false)
  const popupRef = useRef(null)

  const validateForm = () => {
    const errors = {}
    let isValid = true

    if (!formData.name) {
      errors.name = "Name is required."
      isValid = false
    }
    if (!formData.mobile || !/^\d{10}$/.test(formData.mobile)) {
      errors.mobile = "Enter a valid 10-digit mobile number."
      isValid = false
    }
    if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      errors.email = "Enter a valid email address."
      isValid = false
    }

    setFormErrors(errors)
    return isValid
  }

  const handleDownloadBrochure = async (e) => {
    e.preventDefault()
    if (validateForm()) {
      setLoading(true)
      setSubmitStatus(null)

      try {
        // Create form data to send to the server
        const formDataToSend = new FormData()
        formDataToSend.append("name", formData.name)
        formDataToSend.append("mobile", formData.mobile)
        formDataToSend.append("email", formData.email)

        // PHP endpoint to send the email
        const phpEndpoint = "https://admin.lumetiq.in/sendEmail.php"

        const response = await axios.post(phpEndpoint, formDataToSend, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })

        console.log("Response:", response)

        if (response.status === 200) {
          setSubmitStatus({ type: "success", message: "Email sent successfully!" })

          // Brochure download logic
          const brochureUrl = "https://admin.lumetiq.in/assets/LUMETIQ CATALOG-2020.pdf" // Update the URL accordingly
          const link = document.createElement("a")
          link.href = brochureUrl
          link.download = "Brochure.pdf" // Set the file name for download
          document.body.appendChild(link)
          link.click() // Simulate click to trigger download
          document.body.removeChild(link) // Clean up by removing the link from DOM

          // Reset form after download
          setShowPopup(false)
          setFormData({ name: "", mobile: "", email: "" })
        } else {
          setSubmitStatus({ type: "error", message: "Failed to send email. Please try again." })
        }
      } catch (error) {
        console.error("Error details:", error)
        let errorMessage = "Network error occurred. Please check your connection and try again."
        if (error.response) {
          console.error("Error response data:", error.response.data)
          if (error.response.status === 404) {
            errorMessage = "Email service not found. Please check the path to your PHP file."
          } else if (error.response.status === 403) {
            errorMessage = "Access to email service is forbidden. Please check server permissions."
          }
        } else if (error.request) {
          console.error("Error request:", error.request)
          errorMessage = "No response from server. Please try again later."
        }

        setSubmitStatus({ type: "error", message: errorMessage })
      } finally {
        setLoading(false)
      }
    }
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({ ...prevData, [name]: value }))
    // Clear error for this field when user starts typing
    if (formErrors[name]) {
      setFormErrors((prev) => ({ ...prev, [name]: null }))
    }
  }

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (popupRef.current && !popupRef.current.contains(e.target)) {
        onClose()
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [onClose])

  return (
    <div
      id="popup-overlay"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 999,
      }}
    >
      <div
        id="popup-content"
        ref={popupRef}
        style={{ background: "white", padding: "20px", maxWidth: "400px", margin: "auto", borderRadius: "5px" }}
      >
        <h2>Fill the Form to Download Brochure</h2>
        <form onSubmit={handleDownloadBrochure}>
          <div className="form-group">
            <label>Name:</label>
            <input type="text" name="name" value={formData.name} onChange={handleInputChange} />
            {formErrors.name && <p className="error">{formErrors.name}</p>}
          </div>

          <div className="form-group">
            <label>Mobile:</label>
            <input type="text" name="mobile" value={formData.mobile} onChange={handleInputChange} />
            {formErrors.mobile && <p className="error">{formErrors.mobile}</p>}
          </div>

          <div className="form-group">
            <label>Email:</label>
            <input type="email" name="email" value={formData.email} onChange={handleInputChange} />
            {formErrors.email && <p className="error">{formErrors.email}</p>}
          </div>

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <button className="tp-btn-border" type="submit" disabled={loading}>
              {loading ? "Sending..." : "Download"}
            </button>
            <button className="btn1" type="button" onClick={onClose}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

// ✅ Styles
const inputStyle = {
  padding: "8px 12px",
  borderRadius: "20px",
  backgroundColor: "#fff",
  color: "#029FE3",
  border: "1px solid #029FE3",
  fontWeight: "500",
  fontSize: "13px",
  cursor: "pointer",
  width: "100%",
  marginTop: "10px",
}

const buttonStyle = {
  padding: "8px 12px",
  borderRadius: "20px",
  backgroundColor: "#fff",
  color: "#029FE3",
  border: "1px solid #029FE3",
  fontWeight: "500",
  fontSize: "13px",
  cursor: "pointer",
  width: "100%",
}

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0,0,0,0.5)",
  zIndex: 1000000,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}

const popupStyle = {
  background: "white",
  padding: "20px",
  borderRadius: "10px",
  width: "450px",
  maxWidth: "90%",
}
;<style>
  {`
  #popup-overlay {
position: fixed;
top: 0;
left: 0;
width: 100%;
height: 100%;
background-color: rgba(0, 0, 0, 0.5);
display: flex;
justify-content: center;
align-items: center;
z-index: 9999;
}

#popup-content {
background-color: #ffffff;
padding: 30px;
border-radius: 12px;
box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
width: 100%;
max-width: 500px;
animation: fadeIn 0.3s ease-in-out;
}

#popup-content h2 {
margin-bottom: 20px;
text-align: center;
color: #333;
}

.form-group {
margin-bottom: 15px;
}

.form-group label {
display: block;
margin-bottom: 5px;
font-weight: 600;
color: #444;
}

.form-group input {
width: 100%;
padding: 10px;
border: 1px solid #ccc;
border-radius: 6px;
outline: none;
transition: border 0.3s ease;
}

.form-group input:focus {
border-color: #0078ff;
}

.error {
color: #ff3b3b;
font-size: 12px;
margin-top: 5px;
}

.status-message {
padding: 10px;
border-radius: 4px;
margin-bottom: 15px;
text-align: center;
}

.status-message.success {
background-color: #d4edda;
color: #155724;
border: 1px solid #c3e6cb;
}

.status-message.error {
background-color: #f8d7da;
color: #721c24;
border: 1px solid #f5c6cb;
}

#popup-buttons {
display: flex;
justify-content: space-between;
margin-top: 15px;
}

#popup-buttons button {
padding: 10px 20px;
border: none;
border-radius: 6px;
cursor: pointer;
background-color: #0078ff;
color: #fff;
}

.btn1 {
font-size: 12px;
text-transform: uppercase;
line-height: 22px;
font-weight: 500;
color: var(--tp-common-black);
letter-spacing: 0.18em;
padding: 20px 40px;
border: 1px solid rgba(135, 135, 135, .25);
display: inline-block;

&:hover {
background-color:red;
color: var(--tp-common-white);

& span svg:first-child,
& span i:first-child {
opacity: 1;
transform: translateZ(0);
}

& span svg:last-child,
& span i:last-child {
opacity: 0;
transform: translateX(30px) translateY(0);
}
}
}

#popup-buttons button:last-child {
background-color: #ff3b3b;
}

@keyframes fadeIn {
from {
opacity: 0;
transform: scale(0.9);
}
to {
opacity: 1;
transform: scale(1);
}
}
`}
</style>
export default ChatbotPopup
